import React, { useMemo } from "react";
import { map } from "jquery";
import { Cart } from "../../../types/models/mvcapi";
import TranslateManager from 'ts-translate-js';

const tr = TranslateManager.boundTR;
const accounting = require('accounting');

type CartItemLabelProps = {
    cart: Cart;
}; 

export function CartItemLabel({ cart }: CartItemLabelProps) {
    const activeCards = useMemo(() => map(cart?.Items, (item) => {
        const cartItems = [];
        item.Tickets.forEach((ticket) => {
            cartItems.push(<div className="cart-item">
                <div className="item-info">
                    <div>{ticket.SeatName}</div>
                    <div>{ticket.PriceName}</div>
                    <div className="price">{accounting.formatMoney(ticket.Total)}</div>
                </div>
            </div>);
        });
        return cartItems;
    }), [cart]);

    return (cart.Items.length > 0 && <div>
            <div className="cart-item-label">{activeCards}</div>
            <div className="selected-ticket-footer">
                <div className='total-container'>
                    <div className='total'>{tr("Total")} {accounting.formatMoney(cart.Total)}</div>
                    {cart.TotalFeesAndShippingFees > 0 && <div className='info'>{`${tr("Inclut des frais de")} ${accounting.formatMoney(cart.TotalFeesAndShippingFees)}`}</div>}
                </div>
            </div>
        </div>
    );
}